import { _ as tt } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import "./web.set-timeout-72b6430f.js";
import { zIndices as ot } from "@ucl/shared-component-foundations";
import { c as g } from "./index-8b07dec9.js";
import h, { useRef as w, useState as A, useMemo as rt, useEffect as B, useCallback as y } from "react";
import { createPortal as et } from "react-dom";
import I, { css as R } from "styled-components";
import "./es.object.keys-9d66766f.js";
import { usePopoverIndex as it } from "./usePopoverIndex.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as nt } from "./getMetrics-953aa4f8.js";
import { useEventListener as pt } from "./useEventListener.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as at } from "./useWindowSize.js";
import { a as lt } from "./index-5d0f31c6.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import { uniqueId as X } from "./uniqueId.js";
import { g as mt } from "./getElementPosition-8d0dbc61.js";
import { jsxs as L, Fragment as st, jsx as W } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./function-apply-4756dee6.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./array-method-is-strict-e5a3c878.js";
import "./getTarget-19e0f923.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
import "./string-trim-14e37ad3.js";
import "./es.date.to-string-6ed49878.js";
import "./es.global-this-a7f40ce1.js";
import "./es.parse-int-d7709701.js";
import "./es.string.starts-with-a6645e0a.js";
var e = /* @__PURE__ */ function(t) {
  return t.AUTO = "auto", t.TOP = "top", t.BOTTOM = "bottom", t.LEFT = "left", t.RIGHT = "right", t.TOP_START = "top-start", t.TOP_END = "top-end", t.BOTTOM_START = "bottom-start", t.BOTTOM_END = "bottom-end", t.RIGHT_START = "right-start", t.RIGHT_END = "right-end", t.LEFT_START = "left-start", t.LEFT_END = "left-end", t;
}({}), ut = ["title", "children", "placement", "className", "isDisabled", "exceedOverflow"], Y = /* @__PURE__ */ I.div.withConfig({
  displayName: "tooltip__StyledTooltip",
  componentId: "sc-113ivdb-0"
})(["&.Tooltip{", ";}"], function(t) {
  var i = t.theme.components.tooltip;
  return R(i.Tooltip);
}), ct = /* @__PURE__ */ I.div.withConfig({
  displayName: "tooltip__ContentWrapper",
  componentId: "sc-113ivdb-1"
})(["&.Tooltip__content-wrapper{", ";}"], function(t) {
  var i = t.theme.components.tooltip;
  return R(i.ContentWrapper);
}), ft = /* @__PURE__ */ I.div.withConfig({
  displayName: "tooltip__Content",
  componentId: "sc-113ivdb-2"
})(["&.Tooltip__content{", ";}"], function(t) {
  var i = t.theme.components.tooltip;
  return R(i.Content);
}), Tt = /* @__PURE__ */ I.span.withConfig({
  displayName: "tooltip__Pointer",
  componentId: "sc-113ivdb-3"
})(["&.Tooltip__pointer{", ";}"], function(t) {
  var i = t.theme.components.tooltip;
  return R(i.Pointer);
}), dt = function(i, S, C, s) {
  var f = i.getBoundingClientRect(), T = S.clientHeight + 1, O = S.clientWidth + 1, o = f.top < T, n = f.left < O, p = f.right + O > C - 1, a = f.bottom + T > s - 1, l = o && p, d = o && n, N = a && n, M = a && p;
  if (!(!o && !p && !n && !a))
    return !o && !p && !n ? e.TOP : N && !o && !p ? e.TOP_END : M && !o && !n ? e.TOP_START : !a && !p && !n ? e.BOTTOM : d && !a && !p ? e.BOTTOM_END : l && !a && !n ? e.BOTTOM_START : p && !n ? e.LEFT : !p && n ? e.RIGHT : e.TOP;
};
function Z(t) {
  var i = t.title, S = t.children, C = t.placement, s = C === void 0 ? e.AUTO : C, f = t.className, T = t.isDisabled, O = t.exceedOverflow, o = O === void 0 ? !1 : O, n = tt(t, ut), p = nt({
    label: "ToolTip"
  }), a = w(null), l = w(null), d = w(null), N = A({}), M = N[0], F = N[1], P = w(X("tooltip")), H = w(X("tooltip_content")), j = P.current + " " + H.current, z = h.Children.map(S, function(r) {
    return /* @__PURE__ */ h.isValidElement(r) && r.type && r.type === lt ? /* @__PURE__ */ h.cloneElement(r, {
      role: "button",
      "aria-labelledby": j
    }) : /* @__PURE__ */ h.isValidElement(r) ? /* @__PURE__ */ h.cloneElement(r, {
      "aria-labelledby": j
    }) : r;
  }), k = at(), G = k.width, K = k.height, U = A(!1), u = U[0], x = U[1], V = it(u, Z.zIndex), _ = rt(function() {
    return s === "above" ? e.TOP : s === "below" ? e.BOTTOM : s;
  }, [s]), $ = A(_ === e.AUTO ? e.TOP : _), m = $[0], q = $[1];
  B(function() {
    q(_ === e.AUTO ? e.TOP : _);
  }, [_]);
  var J = y(function() {
    if (!(!a.current || !l.current || o)) {
      var r = dt(a.current, l.current, G, K);
      r && r !== m && q(r);
    }
  }, [o, m, K, G]);
  B(function() {
    u && s === "auto" && J();
  }, [u, s, J]);
  var E = y(function() {
    d.current && (clearTimeout(d.current), d.current = null);
  }, []), b = y(function() {
    if (!T) {
      if (!o) {
        if (!l.current)
          return;
        l.current.style.display = "block";
      }
      E(), x(!0);
    }
  }, [E, o, T]), v = y(function() {
    T || (E(), o || (d.current = setTimeout(function() {
      l.current && (l.current.style.display = "none");
    }, 300), x(!1)), o && (d.current = setTimeout(function() {
      x(!1);
    }, 100)));
  }, [E, o, T]), D = y(function() {
    if (!u || !o)
      return F({});
    var r = mt(a, l, m, "tooltip");
    F(r);
  }, [o, u, m]);
  B(function() {
    return D();
  }, [D]), pt("scroll", D, void 0, !0);
  var Q = function() {
    var c;
    return /* @__PURE__ */ L(ct, {
      ref: l,
      role: "tooltip",
      "aria-hidden": !u,
      "aria-label": n["aria-label"] || "Tooltip",
      onMouseOver: b,
      onMouseOut: v,
      className: g(["Tooltip__content-wrapper", "Tooltip__content-wrapper--" + m, "" + (o && "Tooltip__content-wrapper--exceed"), (c = {}, c["Tooltip__content-wrapper--" + m + "-open"] = u, c["Tooltip__content-wrapper--open"] = u, c)]),
      style: o ? Object.assign({}, M, {
        zIndex: V,
        display: "block"
      }) : {
        zIndex: V,
        display: "none"
      },
      children: [/* @__PURE__ */ W(ft, {
        className: g(["Tooltip__content"]),
        id: H.current,
        children: i
      }), /* @__PURE__ */ W(Tt, {
        className: g(["Tooltip__pointer", "Tooltip__pointer--" + m])
      })]
    });
  };
  return o ? /* @__PURE__ */ L(st, {
    children: [/* @__PURE__ */ W(Y, Object.assign({
      className: g(["Tooltip", "Tooltip--" + m, f])
    }, p, {
      ref: a,
      onMouseOver: b,
      onMouseOut: v,
      onFocus: b,
      onBlur: v,
      id: P.current,
      onKeyDown: function(c) {
        return c.code === "Escape" && v();
      },
      children: z
    })), !!i && /* @__PURE__ */ et(Q(), document.body)]
  }) : /* @__PURE__ */ L(Y, Object.assign({
    className: g(["Tooltip", "Tooltip--" + m, f])
  }, p, n, {
    ref: a,
    onMouseOver: b,
    onMouseOut: v,
    onFocus: b,
    onBlur: v,
    id: P.current,
    onKeyDown: function(c) {
      return c.code === "Escape" && v();
    },
    children: [z, !!i && Q()]
  }));
}
Z.zIndex = ot.tooltip;
export {
  Z as Tooltip
};
